export default __webpack_public_path__ + "static/media/bruceWelcome.34006647.jpg";